import { SingleMenuItem } from '@mprolab/uikit'
import { userPanelConfig } from 'config'

/**
 * The user menu, assembled.
 *
 * Extracted from the panel so the order the operator asked for is a fact a
 * test can hold rather than a shape that happens to fall out of a render:
 * the places you can go, then Terminal (where you leave the browser), then
 * Logout — each of the last two opening its own group with a separator.
 */
export function buildUserMenu({
  signedIn,
  logout,
  logoutIcon
}: {
  signedIn: boolean
  logout: () => void
  logoutIcon?: React.ReactNode
}): SingleMenuItem[] {
  if (!signedIn) return userPanelConfig
  return [
    ...userPanelConfig,
    {
      label: 'Logout',
      ...(logoutIcon ? { endIcon: logoutIcon } : {}),
      onClick: logout,
      hoverableIcon: true,
      // Its own group: leaving is not one of the places you can go.
      divider: true
    }
  ]
}
